import { forwardRef, ReactNode } from 'react'
import { RightChevron } from '../../../../icons/questionnaire/RightChevron'

type ListItemProps = {
  icon?: ReactNode // expect an SVG React component, e.g. <SomeIcon />
  label?: string
  labelClassName?: string
  rightIcon?: ReactNode
  onClick?: () => void
  /** Hint announced after name + role (maps to accessibilityHint). */
  'aria-description'?: string
}

const ListItem = forwardRef<HTMLButtonElement, ListItemProps>(function ListItem(
  {
    icon,
    label,
    labelClassName,
    rightIcon,
    onClick,
    'aria-description': ariaDescription
  },
  ref
) {
  return (
    <button
      ref={ref}
      type='button'
      aria-description={ariaDescription}
      className='flex flex-row justify-between px-4 pt-[14px] pb-4 cursor-pointer w-full bg-transparent border-none text-left'
      onClick={onClick}
    >
      <div className='flex flex-row gap-[14px] items-end'>
        {/* Make sure the icon is 18px always */}
        <div aria-hidden='true'>{icon}</div>
        <div className={`text-13 font-medium ${labelClassName ?? ''}`}>{label}</div>
      </div>
      <div aria-hidden='true'>
        {rightIcon ?? <RightChevron />}
      </div>
    </button>
  )
})

export default ListItem

type ListItemGroupProps = {
  children: ReactNode
}

export function ListItemGroup({ children }: ListItemGroupProps) {
  const items = Array.isArray(children) ? children : [children]

  return (
    <div className='w-full'>
      {items.map((child, index) => (
        <div key={index}>
          {child}
          {index < items.length - 1 && <div className='h-[2px] bg-[#F0F4F7]' />}
        </div>
      ))}
    </div>
  )
}
